import { render, staticRenderFns } from "./ProgramaUniversidadNacionalLayout.vue?vue&type=template&id=1d9f8e4d"
import script from "./ProgramaUniversidadNacionalLayout.vue?vue&type=script&lang=js"
export * from "./ProgramaUniversidadNacionalLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports